import validate from 'jquery-validation';
import translations from '../../../lang/translations';
import { setupSelectCountryStateCity } from './form/form-stara';
validate;

function setupContactForm() {
    $('.contact-form').validate({
        onFocusOut: true,
        errorClass: 'input-error',
        errorElement: 'span',
        errorLabelContainer: '.contact-form .errors',
        rules: {
            name: 'required',
            email: {
                required: true,
                email: true,
            },
            phone: {
                required: true,
                minlength: 8,
            },
            country_id: { number: true, required: true },
            city_id: 'number',
            state_id: 'number',
            contact_subject_id: { number: true, required: true },
            unit_id: { number: true, required: true },
            message: 'required',
            privacy: 'required',
        },
        messages: translations[window.currentLocale()],
        invalidHandler: function () {
            $('.contact-form .btn-submit').removeClass('loading');
            $('.contact-form .success').empty();
            reloadCaptcha('contact');
        },
        submitHandler: function (form, event) {
            if ($('.contact-form .btn-submit').hasClass('loading')) {
                return;
            }

            $('.contact-form .btn-submit').addClass('loading');

            event.preventDefault();
            event.stopPropagation();

            reloadCaptcha('contact', 'g-recaptcha-response', function () {
                $.ajax({
                    type: 'POST',
                    url: $(form).data('action'),
                    data: $(form).serialize(),
                    success: function (data) {
                        form.reset();
                        $('.contact-form .success').html(data);
                        $('.contact-form .btn-submit').removeClass('loading');

                        gaContactEventSuccess();
                    },
                    error: function (data) {
                        $('.contact-form .success').empty();
                        $('.contact-form .btn-submit').removeClass('loading');

                        $('.contact-form .errors')
                            .html(
                                data.responseJSON && data.responseJSON.errors
                                    ? Object.values(data.responseJSON.errors).map((v) => v[0] + '<br>')
                                    : data.responseJSON.message || data.responseText
                            )
                            .show({ duration: 0 });

                        try {
                            reloadCaptcha('contact');
                        } catch (e) {
                            console.log(e);
                        }
                    },
                });
            });
        },
    });
}

function gaContactEventSuccess() {
    var idSubject = $('.contact').data('subject-id');
    var eventName = 'form_submit_orcamento';
    if (idSubject == '2') {
        eventName = 'form_submit_pecas';
    } else if (idSubject == '3') {
        eventName = 'form_submit_posvenda';
    } else if (idSubject == '4') {
        eventName = 'form_submit_outros';
    }
    try {
        gtag('event', eventName);
    } catch (e) {
        console.log('gtag not exist', eventName);
    }
}

function setupContact(id, el) {
    $('.contact').attr('data-subject-id', id);

    if (id == 1 || id == 3) {
        id = 2;
    } else {
        id = 1;
    }

    $('.contact .btn-contact').removeClass('border-b-primary text-primary border-b-transparent text-dark bg-[#F0F0F0]');
    $(el).addClass('border-b-primary text-primary bg-[#F0F0F0]');
    $('.contact .btn-contact').not(el).addClass('border-b-transparent text-dark');

    //Container
    $('.contact .contact-form-section').addClass('hidden').removeClass('flex');
    $(".contact .contact-form-section[data-id='" + id + "']")
        .removeClass('hidden')
        .addClass('flex');
}

function initialize() {
    let subject = $('.contact').data('subject');
    setupContact(subject, $(`.contact .btn-contact[data-id="${subject}"]`));
    setupContactForm();
    $('.contact .btn-contact').on('click', function (el) {
        setupContact($(this).data('id'), $(el.target));
    });
    setupSelectCountryStateCity($('.contact-form'));
}

initialize();
